export const ADMIN_FETCH_COWS_REQUEST = 'ADMIN_FETCH_COWS_REQUEST';
export const ADMIN_FETCH_COWS_SUCCESS = 'ADMIN_FETCH_COWS_SUCCESS';
export const ADMIN_FETCH_COWS_FAIL = 'ADMIN_FETCH_COWS_FAIL';
export const ADMIN_FETCH_COW_REQUEST = 'ADMIN_FETCH_COW_REQUEST';
export const ADMIN_FETCH_COW_SUCCESS = 'ADMIN_FETCH_COW_SUCCESS';
export const ADMIN_FETCH_COW_FAIL = 'ADMIN_FETCH_COW_FAIL';
export const ADMIN_ADD_COW_REQUEST = 'ADMIN_ADD_COW_REQUEST';
export const ADMIN_ADD_COW_SUCCESS = 'ADMIN_ADD_COW_SUCCESS';
export const ADMIN_ADD_COW_FAIL = 'ADMIN_ADD_COW_FAIL';
export const ADMIN_UPDATE_COW_REQUEST = 'ADMIN_UPDATE_COW_REQUEST';
export const ADMIN_UPDATE_COW_SUCCESS = 'ADMIN_UPDATE_COW_SUCCESS';
export const ADMIN_UPDATE_COW_FAIL = 'ADMIN_UPDATE_COW_FAIL';
export const ADMIN_DELETE_COW_REQUEST = 'ADMIN_DELETE_COW_REQUEST';
export const ADMIN_DELETE_COW_SUCCESS = 'ADMIN_DELETE_COW_SUCCESS';
export const ADMIN_DELETE_COW_FAIL = 'ADMIN_DELETE_COW_FAIL';
export const ADMIN_REGISTER_REQUEST = 'ADMIN_REGISTER_REQUEST';
export const ADMIN_REGISTER_SUCCESS = 'ADMIN_REGISTER_SUCCESS';
export const ADMIN_REGISTER_FAIL = 'ADMIN_REGISTER_FAIL';
export const ADMIN_CLEAR_REGISTRATION = 'ADMIN_CLEAR_REGISTRATION';
export const ADMIN_REG_CONFIRM_REQUEST = 'ADMIN_REG_CONFIRM_REQUEST';
export const ADMIN_REG_CONFIRM_SUCCESS = 'ADMIN_REG_CONFIRM_SUCCESS';
export const ADMIN_REG_CONFIRM_FAIL = 'ADMIN_REG_CONFIRM_FAIL';
export const ADMIN_SET_COW_PAGE = 'ADMIN_SET_COW_PAGE';
export const ADMIN_SET_COW_PAGE_SIZE = 'ADMIN_SET_COW_PAGE_SIZE';
export const ADMIN_SET_ANIMAL_SORT = 'ADMIN_SET_ANIMAL_SORT';
export const ADMIN_SET_PWD_REQUEST = 'ADMIN_SET_PWD_REQUEST';
export const ADMIN_SET_PWD_SUCCESS = 'ADMIN_SET_PWD_SUCCESS';
export const ADMIN_SET_PWD_FAIL = 'ADMIN_SET_PWD_FAIL';
export const ADMIN_UPDATE_PWD_REQUEST = 'ADMIN_UPDATE_PWD_REQUEST';
export const ADMIN_UPDATE_PWD_SUCCESS = 'ADMIN_UPDATE_PWD_SUCCESS';
export const ADMIN_UPDATE_PWD_FAIL = 'ADMIN_UPDATE_PWD_FAIL';
export const ADMIN_SET_FILTER_ATTR = 'ADMIN_SET_FILTER_ATTR';
export const ADMIN_SET_FILTER_OPERATOR = 'ADMIN_SET_FILTER_OPERATOR';
export const ADMIN_SET_FILTER_VALUE = 'ADMIN_SET_FILTER_VALUE';
